import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadiusFull, space1, space2, space6 } = theme();

  return StyleSheet.create({
    wrapper: {
      borderRadius: borderRadiusFull,
      paddingHorizontal: space2,
      paddingVertical: space1,
    },
    wrapperSmall: {
      maxHeight: space6,
      paddingBottom: space1,
      paddingTop: space1,
    },
  });
};

export { style };
